<!-- @format -->

<ng-container *transloco="let t">
  <div class="container">
    <fudis-body-text variant="md-light">
      <transloco key="FEEDBACK.THANK_YOU.BODY" />
    </fudis-body-text>
    <fudis-body-text class="fudis-mt-sm">
      <fudis-button [label]="t('FEEDBACK.THANK_YOU.GO_TO_FRONTPAGE')" (handleClick)="goToFrontPage()" />
    </fudis-body-text>
  </div>
</ng-container>
